import cc from './cc'
import sales from './sales'
import technical from './technical'

export default {
  cc,
  sales,
  technical
}
